import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TextField from './../TextField/TextField'
import { Autocomplete } from '@mui/material'

const Autocomplete2 = props => {
  const {
    value,
    options,
    lovCallback,
    onChange,
    fieldName,
    optionLabelKey,
    error,
    helperText,
    disableCloseOnSelect = false,
    isDisabled,
    isRequired,
    isMultiple,
    isDeferred,
    cacheOptions,
    ...others
  } = props

  const [open, setOpen] = useState(false)
  const [values, setValues] = useState([])
  const [selectedValue, setSelectedValue] = useState(isMultiple ? [] : null)
  const [loading, setLoading] = useState(open && values.length === 0)

  useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value)
    }
    if (lovCallback && !isDeferred) {
      fireCallback()
    } else if (options && options.length > 0) {
      setValues(options)
    } else {
      setValues([])
    }
    // Issue: https://git.target.com/PlatformAP/apex-ui-kit/issues/221
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, value])

  useEffect(() => {
    if (isDeferred && open) {
      lovCallback && fireCallback()
    }
    // Issue: https://git.target.com/PlatformAP/apex-ui-kit/issues/221
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const handleOnInputChange = searchText => {
    lovCallback && fireCallback(searchText)
  }

  const handleOnChange = val => {
    setSelectedValue(val)
    onChange && onChange(val)
  }

  const fireCallback = (searchText = null) => {
    setLoading(true)
    triggerCallback() &&
      (async () => {
        const data = await lovCallback(searchText)
        data && data.length > 0 ? setValues(data) : setValues([])
        setLoading(false)
      })()
  }

  const isEmpty = value => {
    return !value || (Array.isArray(value) && !value.length)
  }

  const triggerCallback = () => {
    return (cacheOptions && isEmpty(values)) || !cacheOptions
  }

  return (
    <Autocomplete
      data-testid="mui-autocomplete"
      multiple={isMultiple}
      disableCloseOnSelect={disableCloseOnSelect}
      autoComplete={true}
      size="small"
      open={open}
      onOpen={() => {
        setOpen(true)
      }}
      onClose={() => {
        setOpen(false)
      }}
      loading={loading}
      options={values}
      value={selectedValue}
      onChange={(event, value) => handleOnChange(value)}
      onInputChange={(event, value) => handleOnInputChange(value)}
      getOptionLabel={option => option[optionLabelKey]}
      renderInput={params => (
        <TextField
          {...params}
          label={fieldName}
          variant="outlined"
          fullWidth
          error={error}
          errorMessage={helperText}
          hintText={helperText}
          required={isRequired}
          data-testid="mui-autocomplete-textfield"
          id="mui-autocomplete-textfield"
        />
      )}
      disabled={!!isDisabled}
      ListboxProps={{ 'data-testid': 'mui-autocomplete-listbox' }}
      {...others}
    />
  )
}

Autocomplete2.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  options: PropTypes.array,
  lovCallback: PropTypes.func,
  onChange: PropTypes.func,
  fieldName: PropTypes.string.isRequired,
  optionLabelKey: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disableCloseOnSelect: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiple: PropTypes.bool,
  isDeferred: PropTypes.bool,
}

export default Autocomplete2
